module.exports = __webpack_public_path__ + "img/total-2.5e8c73bd.png";